import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=17b7b08e&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17b7b08e')) {
      api.createRecord('17b7b08e', component.options)
    } else {
      api.reload('17b7b08e', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=17b7b08e&", function () {
      api.rerender('17b7b08e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zgYUX5HTshti/JS/comp/childrenage.vue"
export default component.exports